import { useEffect, useContext, useCallback } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';

import type { Auth } from '@shared/types';

import useAxios from '@services/api';

import { authContext } from '@store/index';
import { useFetchClient } from './useFetchClient';

// Для обратной совместимости, используем useFetchClient
export const useFetchUser = useFetchClient;

export const useIsMobile = () => {
  const matches = useMediaQuery('(max-width:600px)');

  return matches;
};

export { useTableColumns } from './useTableColumns';
export type { ColumnConfig, UseTableColumnsOptions } from './useTableColumns';
export { useColumnResize } from './useColumnResize';
